var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSacola2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.332 18.7778V7.66667C12.332 5.89856 13.0344 4.20286 14.2847 2.95262C15.5349 1.70238 17.2306 1 18.9987 1C20.7668 1 22.4625 1.70238 23.7127 2.95262C24.963 4.20286 25.6654 5.89856 25.6654 7.66667V18.7778M6.40103 12.1111H31.5988C32.2396 12.111 32.8729 12.2495 33.4552 12.5171C34.0374 12.7847 34.555 13.175 34.9723 13.6613C35.3896 14.1477 35.6968 14.7185 35.8728 15.3346C36.0488 15.9508 36.0895 16.5977 35.9921 17.2311L33.2033 35.3467C32.9611 36.921 32.1634 38.3566 30.9543 39.3936C29.7453 40.4306 28.205 41.0005 26.6121 41H11.3855C9.79303 40.9999 8.25321 40.4298 7.04465 39.3929C5.83609 38.3559 5.03864 36.9206 4.79659 35.3467L2.0077 17.2311C1.91029 16.5977 1.95101 15.9508 2.12704 15.3346C2.30308 14.7185 2.61028 14.1477 3.02758 13.6613C3.44487 13.175 3.9624 12.7847 4.54468 12.5171C5.12696 12.2495 5.76021 12.111 6.40103 12.1111Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSacola2);
export default __webpack_public_path__ + "static/media/sacola2.0b2376db0daf7a93dfd455922d744c9d.svg";
export { ForwardRef as ReactComponent };